export const QUIZ = [
  {
    question: 'Когда начинаете подготовку жилья?',
    answers: [
      {
        text: 'Заранее продумываю всё до мелочей',
        id: 1,
      },
      {
        text: 'За несколько недель обновляю самое важное',
        id: 2,
      },
      {
        text: 'Накануне делаю базовый минимум',
        id: 3,
      },
    ],
  },
  {
    question: 'Насколько праздничным делаете декор?',
    answers: [
      {
        text: 'Полный набор: гирлянды, текстиль, мелочи',
        id: 1,
      },
      {
        text: 'Пара акцентов для атмосферы',
        id: 2,
      },
      {
        text: 'Минимум: небольшая ёлочка или свеча',
        id: 3,
      },
    ],
  },
  {
    question: 'Как работаете с ценами на праздники?',
    answers: [
      {
        text: 'Планирую заранее и регулярно обновляю',
        id: 1,
      },
      {
        text: 'Корректирую по ситуации',
        id: 2,
      },
      {
        text: 'Ставлю чуть выше обычных или оставляю как есть',
        id: 3,
      },
    ],
  },
  {
    question: 'Что готовите для гостей дополнительно?',
    answers: [
      {
        text: 'Маленькие подарки или праздничный набор',
        id: 1,
      },
      {
        text: 'Небольшой комплимент',
        id: 2,
      },
      {
        text: 'Стандартный набор удобств',
        id: 3,
      },
    ],
  },
  {
    question: 'Как организуете уборки и заселения?',
    answers: [
      {
        text: 'В пик загрузки планирую всё на недели вперед',
        id: 1,
      },
      {
        text: 'Как обычно, с небольшими корректировками на срочность ',
        id: 2,
      },
      {
        text: 'По ситуации, без особых изменений',
        id: 3,
      },
    ],
  },
];

export const RESULT_QUIZ = [
  {
    title: '«Новогодний стратег»',
    image: 'strategy',
    text: 'Вы готовитесь заранее и профессионально создаёте праздничное настроение: продумываете атмосферу, обновляете процессы и настраиваете всё так, чтобы гости чувствовали заботу с первого шага. Декабрь — ваш сезон.',
  },
  {
    title: '«Праздничный управленец»',
    image: 'manager',
    text: 'Вы готовитесь поступательно и без спешки: добавляете важные штрихи, создаёте атмосферу уюта и держите баланс между праздником и рабочим ритмом. Ваш подход олицетворяет порядок во всём без лишних хлопот.',
  },
  {
    title: '«Менеджер минимализма»',
    image: 'minimalism',
    text: 'Вы придерживаетесь простоты и действуете по принципу «главное — чтобы работало». Небольшая подготовка, базовый декор и стабильный процесс помогают вам проходить сезон спокойно и практично для бизнеса. ',
  },
];
